<template>
  <div class="parallel-detail-container">
    <loading :show="loadingShow"></loading>
    <Header></Header>
    <div class="top" v-if="seminarDetail != null">
      <div class="title-img">
        <img
          class="banner-title-pc"
          src="../../assets/images/parallelSessions/banner-title-pc.png"
        />
        <img
          class="banner-title-wap"
          src="../../assets/images/parallelSessions/banner-title-wap.png"
        />
      </div>
      <div class="title">{{ seminarDetail.name }}</div>
      <div class="other flex">
        <div class="date flex">
          <img src="../../assets/images/agenda/time.png" alt="" class="icon" />
          <div class="text">{{ seminarDetail.startAndEndDate }}</div>
        </div>
        <div class="address flex">
          <img
            src="../../assets/images/agenda/address.png"
            alt=""
            class="icon"
          />
          <div class="text">{{ seminarDetail.hotel }}</div>
        </div>
      </div>
      <div
        class="sign-up-btn"
        v-show="seminarDetail.name != '许昌分会'"
        v-if="offlineArea == seminarDetail.name"
      >
        已报名
      </div>
      <div
        class="sign-up-btn cs"
        v-show="seminarDetail.name != '许昌分会'"
        v-else
        @click="didClick_signUpOffline"
      >
        报名线下参会
      </div>
    </div>
    <div class="detail-box" v-if="seminarDetail != null">
      <div class="invitation-box">
        <div class="invitation-content">
          <div class="invitation-border" v-html="seminarDetail.intro"></div>
          <!--          <div class="invitation-border">-->
          <!--            首届 “华为伙伴暨开发者大会”-->
          <!--            ，承接“华为中国生态大会”开放共赢的理念和“HDC.Cloud”勇于创新的精神，旨在为伙伴、开发者构建一个开放交流、分享、学习的平台。<br />-->
          <!--            伙伴、开发者既是为客户创造价值的主体，也是能力的承载。“众行者远”，华为将进行多维转变，关注ICT产业中的每一个角色，成为强大的支撑平台，将产业、行业深度融合，形成从技术孵化到商业成功的良性循环，释放更多伙伴、开发者潜力，打造以客户需求为核心的更加创新、开放、共赢的数字未来！-->
          <!--          </div>-->
        </div>
        <div class="invitation-bottom">
          <!--          {{ seminarDetail.startAndEndDate }}-->
        </div>
      </div>
      <Agenda v-if="agendalist.length > 0" :agendaList="agendalist"></Agenda>
      <Partner
        v-if="seminarDetail && seminarDetail.i_partnerid != null"
        :partnerid="seminarDetail.i_partnerid"
      ></Partner>
      <News></News>
    </div>
    <suspension></suspension>
    <cook-tip></cook-tip>
    <foot></foot>
    <unSignUpOld
      :tips2="tips2"
      :btn="btnText"
      ref="unSignUpDialog"
      @didClickunSignUp="didClick_qd"
    ></unSignUpOld>
  </div>
</template>

<script>
import Header from "../../components/HeaderSubSeminar";
import Partner from "../../components/parallelSessions/Partner";
import Foot from "../../components/Foot";
import CookTip from "../../components/CookTip";
import Suspension from "../../components/Suspension";
import Agenda from "../../components/parallelSessions/Agenda";
import { seminarAPI } from "@/services/modules/seminar";
import dayjs from "dayjs";
import { mapState } from "vuex";
import { $config } from "../../conf";
import { $api } from "../../services/api";
export default {
  name: "ParallelDetail",
  data() {
    return {
      seminarId: "", //分会场id
      seminarDetail: null,
      agendalist: [], // 页面显示用的列表
      loadingShow: true,
      offlineArea: null, //已报名的分会场名称
      tips2: "",
      btnText: "确定",
    };
  },
  components: {
    Header,
    Foot,
    CookTip,
    Suspension,
    Agenda,
    Partner,
    News: () => import("../../components/parallelSessions/News.vue"),
    // unSignUp: () => import("../../components/dialog/type/UnSignUp.vue"),
    unSignUpOld: () => import("../../components/dialog/type/UnSignUpOld.vue"),
  },
  computed: mapState({
    userInfo: (state) => state.userInfo.info,
    tokenInfo: (state) => state.userInfo.token,
    isLogin: (state) => !!state.userInfo.token,
    AttendanceStatus: (state) => state.userInfo.AttendanceStatus,
  }),
  created() {},
  mounted() {
    if (this.$route.query && this.$route.query.seminarId) {
      this.seminarId = this.$route.query.seminarId;
      this.getSeminarDeatil(this.$route.query.seminarId);
    }
    //查询我的 购票信息  报名线下会信息
    this.getQrcode();
  },
  methods: {
    getSeminarDeatil(seminarId) {
      seminarAPI
        .getSubSeminarList_onLine()
        .then((res) => {
          if (res.result == 0) {
            let SeminarList = res.content.items;
            //拿出主会场
            let seminarDetail = null;
            let agendalist = [];
            let now = SeminarList.forEach((item2) => {
              const startDate = dayjs(item2.startTime * 1000).format(
                "YYYY年M月D"
              );
              const endDate = dayjs(item2.endTime * 1000).format("YYYY年M月D");
              if (startDate === endDate) {
                item2.startAndEndDate = dayjs(item2.startTime * 1000).format(
                  "YYYY年M月D日"
                );
              } else {
                item2.startAndEndDate =
                  dayjs(item2.startTime * 1000).format("YYYY年M月D") +
                  dayjs(item2.endTime * 1000).format(" - D日");
              }

              if (item2.subSeminarId == seminarId) {
                seminarDetail = item2;
              }
              if (item2.i_seminarid == seminarId) {
                agendalist.push(item2);
              }
            });
            seminarDetail.intro = seminarDetail.intro
              .replace(/style="[^"]+"/g, "")
              .replaceAll(
                "{{",
                "<span style='color:#b4251e;font-family:Microsoft YaHei-Light;font-weight:600;'>"
              )
              .replaceAll("}}", "</span>");
            this.seminarDetail = seminarDetail;
            this.pipeAgendaList(agendalist);
            this.loadingShow = false;
          }
        })
        .catch((err) => {
          this.loadingShow = false;
        });
    },
    pipeAgendaList(list) {
      let json = {};
      for (let item of list) {
        let day = dayjs(item.startTime * 1000).format("MM.DD");
        item.type = item.i_type[0];
        if (!json[day]) {
          json[day] = {
            key: item.startTime,
            date: day,
            date2: dayjs(item.startTime * 1000).format("YYYY-MM-DD"),
            year: dayjs(item.startTime * 1000).format("YYYY"),
            month: dayjs(item.startTime * 1000).format("M月"),
            day: dayjs(item.startTime * 1000).format("DD"),
            time: dayjs(item.startTime * 1000).format("HH:mm"),
            typeObj: {}, //类型对象
            subs: [], //分会场列表
            // subIds: [], //分会场列表ID
          };
        }
        // 不按照会议类型分类
        // json[day].subs.push(item)
        //按照会议类型分类
        let typeObj = json[day].typeObj;
        if (!typeObj[item.type]) {
          typeObj[item.type] = {
            type: item.type,
            list: [item],
          };
          json[day].subs.push(typeObj[item.type]);
        } else {
          typeObj[item.type].list.push(item);
        }
      }
      // console.log(Object.values(json));
      // let listJson = Object.values(json);

      let listJson = Object.values(json);
      let arr = this.seminarDetail.i_typelist.split(","); //默认类型排序
      //类型排序
      listJson.forEach((item) => {
        item.subs2 = [];
      });
      arr.forEach((tyep) => {
        listJson.forEach((list1) => {
          list1.subs.forEach((list2) => {
            if (tyep == list2.type) {
              list1.subs2.push(list2);
            }
          });
        });
      });
      //日期排序
      listJson.sort((a, b) => {
        return a.key - b.key;
      });
      this.agendalist = listJson;
    },
    //报名线下会
    didClick_signUpOffline() {
      if (this.AttendanceStatus == 1 && this.offlineArea != null) {
        this.tips2 = `<span>您已报名“<span style="color:#B4251E ">${this.offlineArea}</span>”，<br>无法再报名其他分会场</span>`;
        this.$refs.unSignUpDialog.showDialog();
        return;
      } else {
        window._hw(
          "send",
          "action",
          "branch_venue_page_meeting_register_click",
          {
            venue_name: "",
          }
        );
        const { signUpOfflineUrl_new } = $config;
        window.location.href = `${signUpOfflineUrl_new}?i_offlineArea=${
          this.seminarDetail.name
        }&channel=${this.$route.query.channel}&returnUrl=${encodeURIComponent(
          location.href
        )}`;
      }
    },
    //获取我的购票信息
    getQrcode() {
      if (this.AttendanceStatus == 1 || this.AttendanceStatus == 2) {
        //如果是报名了线下会  获取门票信息
        $api
          .getQrcode()
          .then((qrcodeInfo) => {
            //判断当前用户是不是三天通票
            if (qrcodeInfo.code == 0) {
              this.offlineArea = qrcodeInfo.data.offlineArea;
            }
          })
          .catch((err) => {
            this.offlineArea = null;
          });
      }
    },
    //点击弹窗 确定按钮 隐藏弹窗
    didClick_qd() {
      this.$refs.unSignUpDialog.hideDialog();
    },
  },
};
</script>
<style lang="scss">
@media screen and (min-width: 992px) {
  .invitation-border {
    font-size: 18px !important;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei !important;
    font-weight: 400 !important;
    //color: #666666!important;
    line-height: 1.5 !important;
    p {
      margin-bottom: 8px;
    }
  }
}

@media screen and (max-width: 992px) {
  .invitation-border {
    font-size: 24px !important;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei !important;
    font-weight: 400 !important;
    //color: #666666!important;
    line-height: 1.5 !important;
    p {
      margin-bottom: 10px;
    }
  }
}
</style>
<style lang="scss" scoped>
@media screen and (min-width: 992px) {
  @import "./css/detail/pc.scss";
}

@media screen and (max-width: 992px) {
  @import "./css/detail/wap.scss";
}
</style>
